"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApplicationTypeSchema = exports.ApplicationTypes = void 0;
const zod_1 = require("zod");
exports.ApplicationTypes = [
    'sssp',
    'tizen',
    'webos',
    'android',
    'chrome',
    'brightsign',
    'linux',
    'windows',
    'default',
    'chromeos',
];
exports.ApplicationTypeSchema = zod_1.z.enum(exports.ApplicationTypes);
